import SmartLabel from 'components/v2/labels/SmartLabel';
import { useField } from 'formik';
import Select from 'react-select';

const ReactSelect = ({ label, options, isMulti, onChange, enableTooltipError, tooltip, ...props }: any) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  const innerOnChange = (value: any) => {
    let newValue = onChange ? onChange(value) : value;
    if (isMulti) {
      setValue(newValue ?? []);
    } else {
      setValue(newValue);
    }
  };

  return (
    <>
      {label && (
        <SmartLabel
          label={label}
          htmlFor={props.id || props.name}
          required={props.required}
          boxStyle={{ marginBottom: 0 }}
          tooltip={tooltip}
          hasValue={
            enableTooltipError
              ? isMulti
                ? field.value && field.value.length > 0
                : !!field.value?.value && field.value?.value !== ''
              : true
          }
          error={enableTooltipError && meta.touched && meta.error ? meta.error : undefined}
        />
      )}
      <Select
        options={options}
        name={field.name}
        value={field.value}
        onChange={innerOnChange}
        onBlur={field.onBlur}
        isMulti={isMulti}
        {...props}
      />
      {meta.touched && meta.error && !props.supressErrors ? <span className="p-error">{meta.error}</span> : null}
    </>
  );
};

export default ReactSelect;
